import * as React from 'react';
import cx from 'classnames';

import './Ellipsis.styles.scss';


function decodeDisplayText(value) {
	if (value == null || typeof value !== 'string') {
		return value;
	}
	if (typeof document !== 'undefined') {
		const t = document.createElement('textarea');
		t.innerHTML = value;
		return t.value;
	}
	return value
		.replace(/&#x2F;/gi, '/')
		.replace(/&#x27;/g, "'")
		.replace(/&quot;/g, '"')
		.replace(/&gt;/g, '>')
		.replace(/&lt;/g, '<')
		.replace(/&amp;/g, '&');
}

export class Ellipsis extends React.Component {
	static defaultProps = {
		withTooltip: true,
	};

	render() {
		const { children, text, withTooltip, width, maxWidth = '100%', className, ...otherProps } = this.props;

		const decodedText = typeof text === 'string' ? decodeDisplayText(text) : text;
		const decodedChildren = typeof children === 'string' ? decodeDisplayText(children) : children;
		const titleSource = text || children;
		const titleValue = typeof titleSource === 'string' ? decodeDisplayText(titleSource) : '';

		return (
			<div
				title={withTooltip ? titleValue : ''}
				style={{ width, maxWidth }}
				className={cx('Ellipsis', className)}
				{...otherProps}
			>
				{decodedText || decodedChildren}
			</div>
		);
	}
}